import { render, staticRenderFns } from "./NewMenu.vue?vue&type=template&id=4f2fe829&scoped=true"
import script from "./NewMenu.vue?vue&type=script&lang=js"
export * from "./NewMenu.vue?vue&type=script&lang=js"
import style0 from "./NewMenu.vue?vue&type=style&index=0&id=4f2fe829&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2fe829",
  null
  
)

export default component.exports